import { render, staticRenderFns } from "./asList.vue?vue&type=template&id=c76c0cd8&scoped=true"
import script from "./asList.vue?vue&type=script&lang=js"
export * from "./asList.vue?vue&type=script&lang=js"
import style0 from "./asList.vue?vue&type=style&index=0&id=c76c0cd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76c0cd8",
  null
  
)

export default component.exports